import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import '../generalMaster/GeneralMaster.scss';
import DataSearch from '../../utils/DataSearch';
import FetchData from '../../providers/dataProvider';
import Avatar from "../../components/common/Avatar";

const GeneralMasterList = () => {
    const navigate = useNavigate()
    const [filteredResults, setfilterResult] = useState([])
    const [search, setSearch] = useState("");
    const [dropdownList, setDropDownList] = useState([
        { dropdown: "Country", listcount: 0 },
        { dropdown: "Currency", listcount: 0 },
        { dropdown: "Documents", listcount: 0 },
        { dropdown: "Designation", listcount: 0 },
        { dropdown: "Department", listcount: 0 }]);

    const { data: countrydata, loading: countryLoading, error: countryError } = FetchData("generalcountry");
    const { data: currencydata, loading: currencyLoading, error: currencyError } = FetchData("generalcurrency");
    const { data: documentlistdata, loading: documentlistLoading, error: documentlistError } = FetchData("generaldocumentTypes");
    const { data: designationdata, loading: designationLoading, error: designationError } = FetchData("generaldesignation");
    const { data: departmentdata, loading: departmentLoading, error: departmentError } = FetchData("generaldepartment");

    const getListCount = (data) => {
        if (Array.isArray(data)) return data.length;
        if (Array.isArray(data?.data)) return data.data.length;
        if (Array.isArray(data?.items)) return data.items.length;
        return 0;
    };

    useEffect(() => {
        setDropDownList([
            { dropdown: "Country", listcount: getListCount(countrydata) },
            { dropdown: "Currency", listcount: getListCount(currencydata) },
            { dropdown: "Documents", listcount: getListCount(documentlistdata) },
            { dropdown: "Designation", listcount: getListCount(designationdata) },
            { dropdown: "Department", listcount: getListCount(departmentdata) }])
    }, [countrydata, currencydata, documentlistdata, designationdata, departmentdata])

    useEffect(() => {
        setfilterResult(dropdownList)
    }, [dropdownList])

    const ApplySearch = () => {
        const SearchResult = DataSearch(dropdownList, search);
        setfilterResult(SearchResult)
    }

    const ViewGeneralMaster = (item) => {

        if (item) {
            navigate('/edit-general-master', {
                state: {
                    row: item?.dropdown
                }
            })
        }
    }
    const addNew = (e, index, item) => { ViewGeneralMaster(item) }

    return (
        <>
            <section id="generalMasterList">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0 py-1">
                            <div className="card general-master-toolbar">
                                <div className="card-body">
                                    <div className="row search-area-row">
                                        <div className="col-xxl-6 col-xl-6 col-lg-5 col-md-4 col-sm-12 col-xs-12 my-auto p-0">
                                            <div>
                                                <p>{filteredResults.length} Results Found</p>
                                            </div>
                                        </div>
                                        <div className="col-xxl-6 col-xl-6 col-lg-7 col-md-8 col-sm-12 col-xs-12 px-1">
                                            <div className="d-flex flex-wrap flex-sm-nowrap justify-content-center justify-content-sm-end">
                                                <div className="input-group text-align">
                                                    <div className="input-group-append">
                                                        {search != '' && <button
                                                            className="btn"
                                                            type="button"
                                                            onClick={(e) => setSearch("")}
                                                        >
                                                            <i className="fas fa-times"></i>
                                                        </button>}
                                                        <button
                                                            className="btn"
                                                            type="button"
                                                            onClick={ApplySearch}
                                                        >
                                                            <i className="fa fa-search"></i>
                                                        </button>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search"
                                                        value={search}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                    />
                                                </div>
                                                <div className="text-align">
                                                    <button
                                                        className="btn refresh-btn"
                                                        type="button"
                                                    >
                                                        <i className="fas fa-redo"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- search-area-sec ends --> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row table-row">
                        {filteredResults.map((item, index) =>
                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" key={item.dropdown}>
                                <div className="card mt-1 general-master-row">
                                    <div className="card-body">
                                        <div className='general-master-row-content'>
                                            <div className='general-master-identity'>
                                                <Avatar preName={item?.dropdown} />
                                                <div className='general-master-copy'>
                                                    <h4>{item.dropdown}</h4>
                                                    <p>Manage {item.dropdown.toLowerCase()} records</p>
                                                </div>
                                            </div>
                                            <div className='general-master-row-actions'>
                                                <div className='master-count-badge'>
                                                    <h5>{item.listcount}</h5>
                                                    <label>Records</label>
                                                </div>
                                                <button className="master-open-btn" type="button" onClick={(e) => addNew(e, index, item)} aria-label={`Open ${item.dropdown}`}>
                                                    <i className="fas fa-chevron-right"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </>
    )
}

export default GeneralMasterList
